import { useLanguage } from '@/contexts/language-context';

import type {
  VisitDateFilter,
  VisitPaymentFilter,
  VisitStatusFilter,
  VisitFilterState,
} from './types';

interface Props {
  filters: VisitFilterState;
  count: number;
  onChange: (patch: Partial<VisitFilterState>) => void;
}

const selectClass =
  'px-3 py-2 text-sm border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring';

export function VisitFilterBar({ filters, count, onChange }: Props) {
  const { t } = useLanguage();

  return (
    <div className="flex flex-wrap items-center gap-2">
      <select
        value={filters.status}
        onChange={(e) =>
          onChange({ status: e.target.value as VisitStatusFilter })
        }
        data-testid="series-filter-status"
        className={selectClass}
      >
        <option value="all">{t.allStatuses}</option>
        <option value="draft">{t.scheduled}</option>
        <option value="started">{t.inProgress}</option>
        <option value="completed">{t.completed}</option>
        <option value="cancelled">{t.cancelled}</option>
      </select>

      <select
        value={filters.payment}
        onChange={(e) =>
          onChange({ payment: e.target.value as VisitPaymentFilter })
        }
        data-testid="series-filter-payment"
        className={selectClass}
      >
        <option value="all">{t.seriesFilterPaymentAll}</option>
        <option value="paid">{t.seriesFilterPaymentPaid}</option>
        <option value="unpaid">{t.seriesFilterPaymentUnpaid}</option>
        <option value="partial">{t.seriesFilterPaymentPartial}</option>
      </select>

      <select
        value={filters.date}
        onChange={(e) => onChange({ date: e.target.value as VisitDateFilter })}
        data-testid="series-filter-date"
        className={selectClass}
      >
        <option value="all">{t.seriesFilterDateAll}</option>
        <option value="past">{t.seriesFilterDatePast}</option>
        <option value="upcoming">{t.seriesFilterDateUpcoming}</option>
      </select>

      <span className="text-xs text-muted-foreground ml-auto">{count}</span>
    </div>
  );
}
